<template>
  <base-draggable-modal
      name="base_document_settings"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="base_document_settings">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate('document_types') }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
            <v-card-text>
              <v-row v-for="(document_type, index) in document_types" :key="index">
                <v-col>
                  <v-autocomplete
                      class="reg-normal text-primary"
                      base-color="border-tertiary"
                      bg-color="secondary"
                      color="primary"
                      density="default"
                      v-model="document_type.type"
                      :items="$lodash.sortBy(types, 'text')"
                      :return-object="false"
                      item-value="value"
                      item-title="text"
                      hide-details
                      clearable>
                    <template #label>
                      <span class="sm-normal text-subtle">{{ $store.getters.translate('type') }}</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col>
                  <v-autocomplete
                      class="reg-normal text-primary"
                      base-color="border-tertiary"
                      bg-color="secondary"
                      color="primary"
                      density="default"
                      v-model="document_type.subtype"
                      :items="$lodash.sortBy(subtypes, 'text')"
                      :return-object="false"
                      item-value="value"
                      item-title="text"
                      hide-details
                      clearable>
                    <template #label>
                      <span class="sm-normal text-subtle">{{ $store.getters.translate('subtype') }}</span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "./BaseActionButton";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  props: ["project_id"],
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhFloppyDisk, PhX,
  },
  data() {
    return {
      types: [],
      subtypes: [],
      document_types: [],
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal('base_document_settings');
      await this.getDocumentTypes();
      if(this.types.length === 0 && this.subtypes.length === 0) {
        await this.getTypesAndSubtypes();
      }
    },
    async save() {
      await helpFunctions.postCustomRoute(this.$toast, "update-document-types", { project_id: this.project_id, document_types: this.document_types }, true, true);
      this.$emit('refresh');
      this.reset();
    },
    async getTypesAndSubtypes() {
      let types_and_subtypes = await helpFunctions.getFullAdditionalModels(this.$toast, "typesandsubtype", true);
      this.types = [{text: '', value: ''}];
      this.subtypes = [];
      types_and_subtypes.forEach((option) => {
        if(option.type === 'type') {
          this.types.push({ text: option.name, value: option.name });
        }
        else if(option.type === 'subtype') {
          this.subtypes.push({ text: option.name, value: option.name });
        }
      });
    },
    async getDocumentTypes() {
      let document_types_temp = await helpFunctions.postCustomRoute(this.$toast, "get-document-types", { project_id: this.project_id }, false, true);
      this.document_types = [];
      document_types_temp.forEach((document_type) => {
        this.document_types.push({ type: document_type.type, subtype: document_type.subtype });
      });
      for (let i = 0; i < 3; i++) {
        this.document_types.push({ type: null, subtype: null });
      }
    },
    reset() {
      this.document_types = [];
      this.closeModal('base_document_settings');
    },
  },
};
</script>